import React from 'react';
import { observer } from '../../shared/observer';
import { isBusy } from '../../shared/busy';
import { curFormat, dateFormat } from '../../shared/format';
import { statusMod, orderAddressLine } from '../../shared/orderStatus';
import { repeatOrder, cancelOrder, changePayType, payOrderOnline } from '../../shared/orderActions';

// Полная карточка заказа со всеми действиями (повтор, отмена, смена и
// проведение оплаты). Используется на экране #orders и в секции активных,
// и в истории — отличие только в модификаторе .ng-order--active.
//
// props:
//   item      — заказ из v3/orders/list (MobileOrderSerializer). Имя `item`,
//               а не `order`: observer инжектит стор под alias'ом `order`
//               (orderStore → props.order) и затёр бы одноимённый проп.
//   active    — добавить класс .ng-order--active
//   onChanged — перезагрузка списка после отмены/оплаты
class OrderCardView extends React.Component {
  state = { busy: {}, error: null };

  changed = () => {
    const fn = this.props.onChanged;
    return fn ? fn() : null;
  };

  // Сами действия — в shared/orderActions: тот же набор использует страница
  // заказа (OrderDetails).
  repeat = (id) => () => repeatOrder(this, id);

  cancel = (id) => () => cancelOrder(this, id, this.changed);

  changePayType = (id) => (e) => changePayType(this, id, e.target.value);

  payOnline = (id) => () => payOrderOnline(this, id);

  render() {
    const o = this.props.item || {};
    const cur = (this.props.auth.companyInfo.currency_hash && this.props.auth.companyInfo.currency_hash.symbol_html) || '';
    const repeating = isBusy(this, 'repeat:' + o.id);
    const canceling = isBusy(this, 'cancel:' + o.id);
    const payChanging = isBusy(this, 'pay:' + o.id);
    const paying = isBusy(this, 'online:' + o.id);
    const rowBusy = repeating || canceling || payChanging || paying;
    // Кнопка «Оплатить» появляется только у заказа с онлайн-способом оплаты —
    // решает сервер (Orders::ClientOrderPayPolicy), фронт только читает флаг.
    const canPayOnline = !!(o.online_pay && o.online_pay.allowed);
    const payChange = o.pay_type_change;
    const payTypes = (payChange && payChange.pay_types) || [];
    const canChangePayType = !!(payChange && payChange.allowed && payTypes.length);
    const currentInList = payTypes.some((p) => String(p.id) === String(o.pay_type_id));
    const mod = statusMod(o);

    return (
      <article className={'ng-order' + (this.props.active ? ' ng-order--active' : '')}>
        <header className="ng-order__head">
          <div>
            {o.order_num ? (
              <div className="ng-order__num">
                <a href={'#order/' + o.id}>№ {o.order_num}</a>
              </div>
            ) : null}
            <div className="ng-order__date">{dateFormat(o.date)}</div>
            {o.time_from && o.time_to ? (
              <div className="ng-order__when">{o.time_from} - {o.time_to}</div>
            ) : null}
            <div className="ng-order__addr">{orderAddressLine(o)}</div>
          </div>
          <div className={'ng-order__status' + (mod ? ' ng-order__status--' + mod : '')}>
            {o.status}
          </div>
        </header>
        <ul className="ng-order__items">
          {(o.items || []).map((it, i) => (
            <li key={i}>
              <span>{it.title}</span>
              <span>{it.quantity} × {curFormat(it.price)} {cur}</span>
            </li>
          ))}
        </ul>
        {this.state.error && <div className="order-message">{this.state.error}</div>}
        <footer className="ng-order__foot">
          {/* Итого = pay_sum (сумма к оплате: позиции − бонусы − промо + залог
              постамата), как в приложении (overallSum) и в PaymentForm сайта.
              total_sum — голая сумма позиций (Order#save_total_sum), она
              расходилась бы с суммой в кнопке «Оплатить». */}
          <strong>Итого: {curFormat(o.pay_sum)} {cur}</strong>
          {canChangePayType ? (
            <div className="ng-order__addr">
              Оплата:{' '}
              <select
                value={o.pay_type_id || ''}
                disabled={rowBusy}
                onChange={this.changePayType(o.id)}
              >
                {/* Плейсхолдер нужен всегда, когда текущего типа нет в списке:
                    pay_type_id сериализатор отдаёт даже у заказа без явного
                    типа (дефолт компании), и без опции под это значение
                    браузер показал бы чужую подпись. */}
                {!currentInList && (
                  <option value={o.pay_type_id || ''} disabled>
                    {(o.pay_type && o.pay_type.title) || 'Способ не выбран'}
                  </option>
                )}
                {payTypes.map((p) => (
                  <option key={p.id} value={p.id}>{p.title}</option>
                ))}
              </select>
            </div>
          ) : (
            o.pay_type && <div className="ng-order__addr">Оплата: {o.pay_type.title}</div>
          )}
          <div className="ng-order__actions">
            <button
              type="button"
              className={'btn btn--mini' + (repeating ? ' is-busy' : '')}
              disabled={rowBusy}
              onClick={this.repeat(o.id)}
            >
              Повторить
            </button>
            {canPayOnline && (
              <button
                type="button"
                className={'btn btn--mini' + (paying ? ' is-busy' : '')}
                disabled={rowBusy}
                onClick={this.payOnline(o.id)}
              >
                Оплатить
              </button>
            )}
            {o.can_cancel && (
              <button
                type="button"
                className={'btn btn--danger btn--mini' + (canceling ? ' is-busy' : '')}
                disabled={rowBusy}
                onClick={this.cancel(o.id)}
              >
                Отменить
              </button>
            )}
          </div>
        </footer>
      </article>
    );
  }
}

export const OrderCard = observer(OrderCardView, ['orderStore', 'cartStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/OrderCard.jsx